export const FORM_FIELDS = {
  DATE_OF_BIRTH: 'dateOfBirth',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
} as const

export const TEST_IDS = {
  FORM_CONTAINER: 'ADD_DEPENDENT_FORM',
  DATE_OF_BIRTH_PICKER: 'DATE_OF_BIRTH_PICKER',
  FIRST_NAME_INPUT: 'FIRST_NAME_INPUT',
  LAST_NAME_INPUT: 'LAST_NAME_INPUT',
  EMAIL_INPUT: 'EMAIL_INPUT',
  ADULT_TOOLTIP: 'ADULT_DEPENDENT_TOOLTIP',
} as const
